import {createSlice} from '@reduxjs/toolkit';
import {ParkingLotsState} from './types';
import {loadParkingLots} from './actions';

export const initialState: ParkingLotsState = {
  parkingLots: [],
  status: 'NotLoaded',
};

const slice = createSlice({
  name: 'parkingLots',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadParkingLots.rejected, (state) => {
      state.status = 'Failed';
    });
    builder.addCase(loadParkingLots.pending, (state) => {
      state.status = 'Loading';
    });
    builder.addCase(loadParkingLots.fulfilled, (state, action) => {
      state.parkingLots = action.payload;
      state.status = 'Loaded';
    });
  },
});

export const {reducer: parkingLotsReducer} = slice;
